export default {
  LIST_FETCHED: 'JOURNEY_FETCHED',
  LIST_LOAD: 'JOURNEY_LOAD',
  ITEM_DETAIL: 'JOURNEY_DETAIL',
  BUTTON_LOAD: 'JOURNEY_BUTTON_LOAD',
  SUBSCRIBED: 'JOURNEY_SUBSCRIBED',
};
